package com.vizio.redwolf.consent.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class UserConsentV2Response (
    val userId: String,
    val userIdType: String,
    val userExists: Boolean,
    val consents: List<UserConsentResponseData>,
    val consentGroups: List<UserConsentGroupResponseData>,
)

@Serializable
@JsExport
data class UserConsentResponseData(
    val id: String,
    val currentConsentStatus: String,
    val currentConsentVersion: Int? = null,
    val lastInteractedVersion: Int? = null,
    val lastInteractedConsentStatus: String,
)

@Serializable
@JsExport
data class UserConsentGroupResponseData(
    val id: String,
    val currentConsentStatus: String
)